/**
 * Venue Spaces — Room Image Carousel
 * Lightweight vanilla JS: arrows, dots, touch swipe
 * stopPropagation on controls to prevent parent click handlers (e.g. room selection)
 */
(function () {
  'use strict';

  document.querySelectorAll('.tr-room-carousel').forEach(function (carousel) {
    var track = carousel.querySelector('.tr-room-carousel__track');
    var dots  = carousel.querySelectorAll('.tr-room-carousel__dot');
    var prev  = carousel.querySelector('.tr-room-carousel__arrow--prev');
    var next  = carousel.querySelector('.tr-room-carousel__arrow--next');
    var count = parseInt(carousel.dataset.count, 10) || 0;

    if (count <= 1) return;

    var current = 0;

    function goTo(index) {
      if (index < 0) index = count - 1;
      if (index >= count) index = 0;
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    // Arrow clicks — stop propagation so parent card click doesn't fire
    if (prev) prev.addEventListener('click', function (e) {
      e.stopPropagation();
      goTo(current - 1);
    });
    if (next) next.addEventListener('click', function (e) {
      e.stopPropagation();
      goTo(current + 1);
    });

    // Dot clicks — stop propagation
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(i);
      });
    });

    // Touch swipe
    var touchStartX = 0;
    var touchEndX = 0;
    var swipeThreshold = 50;

    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    carousel.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var delta = touchStartX - touchEndX;
      if (Math.abs(delta) > swipeThreshold) {
        if (delta > 0) {
          goTo(current + 1);
        } else {
          goTo(current - 1);
        }
      }
    }, { passive: true });

    // Initialize first dot
    if (dots.length > 0) dots[0].classList.add('is-active');
  });
})();
